import { useContext, type ComponentProps } from 'react';
import { ThemeContext } from 'styled-components';
import SMSIcon from './SMSIcon';

/** SMS glyph for a call that has both a primary and a secondary location. */
export default function AssociatedSMSIcon(
  props: ComponentProps<typeof SMSIcon>,
) {
  const theme = useContext(ThemeContext);
  return <SMSIcon {...props} color={theme?.colors?.lightWarning} />;
}
